import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateTagDto } from './create-tag.dto';

/**
 * Update tag DTO
 */
export class UpdateTagDto extends CreateTagDto {
	@TransformInt()
	id!: number;
}
